
/* istanbul ignore file */

import embLabels from "../../../config/emb-labels-en.json";

export const padNumberFormat = (number) => (number < 10 ? "0" : "") + number;

export const isDuplicates = (arr) => {
  const filtered = arr?.filter((item) => item !== null && item !== undefined);
  return filtered.length !== new Set(filtered).size;
};

export const pvSetGroupName = (component) => {
  let pv1 = [];
  let pv2 = [];
  let pv3 = [];
  const pvData = component?.components?.filter(
    (item) => item.componentType === "Inverter"
  );
  pvData?.forEach((item) => {
    var set = JSON.parse(item.uiAttributes).set;
    var name = JSON.parse(item.attributes).groupName;
    if (set === 1) {
      pv1.push(name);
    } else if (set === 2) {
      pv2.push(name);
    } else {
      pv3.push(name);
    }
  });
  const pvGroupData = [pv1[0], pv2[0], pv3[0]];
  return isDuplicates(pvGroupData);
};

export const DER = [
  "Utility",
  "BESS",
  "Genset",
  "Load",
  "Inverter",
  "EV_charging_station",
];

export const priorityRules = {
  Utility: { derPriority: 0, pmPriority: 1, cbPriority: 2 },
  BESS: { derPriority: 3, pmPriority: 1, cbPriority: 2 },
  Genset: { derPriority: 3, pmPriority: 1, cbPriority: 2 },
  Load: { derPriority: 0, pmPriority: 1, cbPriority: 2 },
  Inverter: { derPriority: 3, pmPriority: 1, cbPriority: 2 },
  EV_charging_station: { derPriority: 3, pmPriority: 1, cbPriority: 2 },
  Grounding_Transformer: {},
};

export const applyPriorityRules = (arrayComponent) => {
  arrayComponent.forEach((arrayComp) => {
    if (!DER.includes(arrayComp.componentType)) return;

    const uiAttr = JSON.parse(arrayComp.uiAttributes);
    let attr = JSON.parse(arrayComp.attributes);

    const rules = { ...priorityRules[arrayComp.componentType] };

    const isLoad = arrayComp.componentType === "Load";
    const isRemoteLoad = uiAttr?.isRemoteLoad;

    if (uiAttr.pmRequired === true && !attr.pmPriority) {
      rules.pmPriority = 1;
    }

    if (uiAttr.pmRequired === false) {
      rules.pmPriority = 0;
      rules.cbPriority = 1;
      rules.derPriority = isLoad && !isRemoteLoad ? 0 : 2;
    }

    if (uiAttr.CBConfigured && !attr.CBPriority) {
      rules.cbPriority = uiAttr.cbRequired
        ? rules.pmPriority === 0
          ? 1
          : 2
        : 0;
    }

    if (uiAttr.cbRequired === false) {
      rules.pmPriority = 1;
      rules.cbPriority = 0;
      rules.derPriority = 2;
    }

    if (uiAttr.cbRequired === false && uiAttr.pmRequired === false) {
      rules.pmPriority = 0;
      rules.cbPriority = 0;
      rules.derPriority = isLoad ? 0 : 1;
    }

    if (uiAttr.derPriority === false && uiAttr.pmRequired === false) {
      rules.pmPriority = 0;
      rules.cbPriority = 1;
      rules.derPriority = 0;
    }

    arrayComp.attributes = JSON.stringify({
      ...attr,
      ...rules,
    });
  });
};

export const isBetween = (num, a, b) => (num - a) * (num - b) <= 0;

export const isValidCBName = (value) =>
  /^[-_0-9a-zA-Z]+$/.test(value) ? true : false;

export const isValidName = (value) =>
  /^[a-zA-Z0-9 ]+$/.test(value) ? true : false;

export const checkForDuplicateName = (name, currentName, allNamesFn) => {
  const ALLNAMES = allNamesFn();
  const OTHERNAMES = ALLNAMES?.filter((n) => n !== currentName);
  return OTHERNAMES.some(
    (existingName) => existingName?.toLowerCase() === name?.toLowerCase()
  );
};

export const getAllNames = (CBAssetList, CBLoadList, CBEVList, PVDetails) => {
  const ASSETNAMES = CBAssetList.map(
    (assetNames) => assetNames?.configData?.name
  );
  const LOADNAME = CBLoadList?.map(
    (loadNames) => loadNames?.configData?.name
  );
  const EVNAMES = CBEVList?.filter((ev) => ev.uiData.status).map(
    (evNames) => evNames?.configData?.name
  );
  const PV1NAME = PVDetails?.pvset1Data.map((pv1names) => pv1names.name);
  const PV2NAME = PVDetails?.pvset2Data.map((pv2names) => pv2names.name);
  const PV3NAME = PVDetails?.pvset3Data.map((pv3names) => pv3names.name);
  return [
    ...ASSETNAMES,
    ...LOADNAME,
    ...EVNAMES,
    ...PV1NAME,
    ...PV2NAME,
    ...PV3NAME,
  ];
};
